import { isPlainObject } from 'lodash/lang';
import moment from 'moment/moment';

const defaultOptions = {
  defaultValue: null,
  useUTC: false,
  tz: undefined,
  tzShow: false
};

export const DEFAULT_DATE_FORMAT = 'DD/MMM/YYYY';

export function formatDate(date, format, options) {
  if (!isPlainObject(options)) {
    options = { defaultValue: options };
  }

  const { defaultValue, useUTC, tz, tzShow } = { ...defaultOptions, ...options };

  if (!date) {
    return defaultValue;
  }
  const m = (useUTC ? moment.utc : moment)(date);

  if (!m.isValid()) {
    return defaultValue;
  }

  let tzAbbr;

  if (tzShow) {
    tzAbbr = tz ? getTimeZoneAbbr(tz) : m.zoneAbbr();
  }

  return (tz ? m.tz(tz) : m).format(format || DEFAULT_DATE_FORMAT) + (tzAbbr ? ` ${tzAbbr}` : '');
}

formatDate.forCsv = function formatDateForCsv(date, format) {
  return formatDate(date, format, { defaultValue: '-', useUTC: true });
};

export function compareDates(left, right) {
  return dateValue(left) - dateValue(right);
}

export function dateValue(value) {
  return value ? new Date(value).getTime() : 0;
}

export function getTimeZoneAbbr(timeZone) {
  let [, ...tz] = new Date().toLocaleTimeString('en', { timeZone, timeZoneName: 'long', hour12: false }).split(' ');
  if (tz.includes('Daylight') || tz.includes('Standard')) {
    return tz[0];
  }
  return moment()
    .tz(timeZone)
    .zoneAbbr();
}
